// ═══════════════════════════════════════════════════════════════
// DATABASE — Firestore accessors for the mechanic's own data.
// All data is scoped under users/{uid}/... to keep the door open
// to multi-mechanic without a schema rewrite.
//
// Phase 0: stubbed. Real CRUD lands in Phase 1. See docs/ARCHITECTURE.md.
// ═══════════════════════════════════════════════════════════════
import { db, auth } from './firebase.js';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';

function requireUid() {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('Not signed in.');
  return uid;
}

// Root reference for the signed-in mechanic's data.
export function mechanicRoot() {
  return doc(db, 'users', requireUid());
}

// Collection helpers — return query-ready CollectionReferences.
export const customersCol   = () => collection(mechanicRoot(), 'customers');
export const vehiclesCol    = () => collection(mechanicRoot(), 'vehicles');
export const jobsCol        = () => collection(mechanicRoot(), 'jobs');
export const estimatesCol   = () => collection(mechanicRoot(), 'estimates');
export const invoicesCol    = () => collection(mechanicRoot(), 'invoices');
export const inspectionsCol = () => collection(mechanicRoot(), 'inspections');
export const receiptsCol    = () => collection(mechanicRoot(), 'receipts');
// Reusable inspection checklists the mechanic builds in Settings.
export const checklistsCol   = () => collection(mechanicRoot(), 'checklists');

// Business profile — single doc per mechanic. Stores name/phone/email/
// address/logoUrl that get snapshot into share/invoice docs at Send time.
export const businessProfileDoc = () => doc(mechanicRoot(), 'profile', 'business');

// Placeholder — Phase 1 will fill these in.
export async function createJob(/* { customerId, vehicleId, lineItems } */) {
  throw new Error('createJob: not implemented yet (Phase 1).');
}
